<template>
  <fieldset class="custom-switch" :class="[`${name}-group`]">
      <input v-model="value_" type="checkbox" role="switch" :id="name" value="1" @click="$emit('clicked', { active: !value_ })">
      <span class="switch"></span>
      <label :aria-label="value_ ? ariaLabelActive : ariaLabelInactive" :for="name"><slot name="lbl">{{name}} (Default-Text)</slot></label>
  </fieldset>
</template>
<script>

import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'LabeledCustomSwitch',
  mixins: [
    syncProperty('value', 'value_')
  ],
  data () {
    return {
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    ariaLabelActive: {
      type: String,
      default: ''
    },
    ariaLabelInactive: {
      type: String,
      default: ''
    }
  },
  methods: { },
  computed: { }
}
</script>
